import {Component} from '@angular/core';
import {FieldType} from "@ngx-formly/core";

@Component({
  selector: 'app-masked-input',
  templateUrl: './masked-input.component.html',
  styleUrl: './masked-input.component.scss'
})
export class MaskedInputComponent extends FieldType {
}
